import { t } from "@/i18n-js/instance";
import type { ConfirmationCardProps } from "../../../types/ChatCard";
import { AccessGroupExecutePreview } from "./execute-previews/AccessGroupExecutePreview";
import { CommunitySegmentExecutePreview } from "./execute-previews/CommunitySegmentExecutePreview";
import { InviteLinkExecutePreview } from "./execute-previews/InviteLinkExecutePreview";
import { MemberExecutePreview } from "./execute-previews/MemberExecutePreview";
import { ProfileFieldExecutePreview } from "./execute-previews/ProfileFieldExecutePreview";
import { SpaceExecutePreview } from "./execute-previews/SpaceExecutePreview";
import { SpaceGroupExecutePreview } from "./execute-previews/SpaceGroupExecutePreview";
import { TagExecutePreview } from "./execute-previews/TagExecutePreview";

type ComponentRenderer = (params: Record<string, unknown>) => JSX.Element;

const PREVIEW_COMPONENTS: Record<string, ComponentRenderer> = {
  title_community_member: params => (
    <MemberExecutePreview
      name={params.name as string}
      email={params.email as string}
    />
  ),
  title_space_group: params => (
    <SpaceGroupExecutePreview
      name={params.name as string}
      member_count={params.member_count as number}
    />
  ),
  title_space: params => (
    <SpaceExecutePreview
      name={params.name as string}
      space_group={params.space_group as string}
      type={params.type as string}
      access={params.access as string}
    />
  ),
  title_invitation_link: params => (
    <InviteLinkExecutePreview
      name={params.name as string}
      status={params.status as string}
      members_joined_count={params.members_joined_count as number}
    />
  ),
  title_member_tag: params => (
    <TagExecutePreview
      name={params.name as string}
      is_public={params.is_public as boolean}
    />
  ),
  title_access_group: params => (
    <AccessGroupExecutePreview
      name={params.name as string}
      description={params.description as string}
      member_count={params.member_count as number}
    />
  ),
  title_profile_field: params => (
    <ProfileFieldExecutePreview
      label={params.label as string}
      field_type={params.field_type as string}
    />
  ),
  title_community_segment: params => (
    <CommunitySegmentExecutePreview
      title={params.title as string}
      people_count={params.people_count as number}
    />
  ),
};

export const ConfirmationCard = ({ title, params }: ConfirmationCardProps) => {
  const titleKey = Object.keys(t("help_widget.copilot.confirmation_card")).find(
    key => t(`help_widget.copilot.confirmation_card.${key}`) === title,
  );

  if (!titleKey) {
    return null;
  }

  const renderer = PREVIEW_COMPONENTS[titleKey];
  if (!renderer) {
    return null;
  }

  return renderer(params as Record<string, unknown>);
};
